
  (function () {
    var root = document.querySelector('.sbh[data-section="sb-home-header"]');
    if (!root || root.dataset.homeHeaderReady) return; root.dataset.homeHeaderReady="true";
    var burger = root.querySelector('.sbh-burger');
    var drawer = root.querySelector('.sbh-drawer');
    var overlay = root.querySelector('.sbh-overlay');
    var closeBtn = root.querySelector('.sbh-close');
    if (!burger || !drawer || !overlay) return;
    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-modal', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.removeAttribute('aria-modal');
      document.body.style.overflow = '';
      // The desktop breakpoint can close a drawer while hiding its trigger.
      var focusTarget = burger.getClientRects().length ? burger : root.querySelector('.sbh-bar > .sb-wordmark');
      if (focusTarget) focusTarget.focus();
    }
    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);

    // Search: toggle the panel below the bar (form still works without JS via the drawer).
    var searchBtn = root.querySelector('.sbh-search-btn');
    var searchPanel = root.querySelector('.sbh-search');
    function closeSearch() {
      if (!searchPanel || searchPanel.hidden) return;
      searchPanel.hidden = true;
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    }
    if (searchBtn && searchPanel) {
      searchBtn.addEventListener('click', function () {
        var willOpen = searchPanel.hidden;
        searchPanel.hidden = !willOpen;
        searchBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) { var inp = searchPanel.querySelector('input'); if (inp) inp.focus(); }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        var focusable = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'), function (el) {
          return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
        });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { e.preventDefault(); return; }
        if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
          e.preventDefault(); first.focus();
        }
        return;
      }
      if (e.key !== 'Escape') return;
      if (drawer.classList.contains('is-open')) close();
      closeSearch();
    });

    // Match the consolidated CSS breakpoint; do not leave a hidden modal or scroll lock.
    window.matchMedia('(min-width: 1024px)').addEventListener('change', function (event) {
      if (!event.matches) return;
      if (drawer.classList.contains('is-open')) close();
      closeSearch();
    });

    // Desktop dropdowns: keep aria-expanded in sync for screen readers. The CSS
    // hover/focus-within reveal still drives the visual; this only sets state.
    Array.prototype.forEach.call(root.querySelectorAll('.sbh-item'), function (item) {
      var trig = item.querySelector('.sbh-link');
      if (!trig) return;
      trig.setAttribute('aria-expanded', 'false');
      function setExp(v) { trig.setAttribute('aria-expanded', v ? 'true' : 'false'); }
      item.addEventListener('mouseenter', function () { setExp(true); });
      item.addEventListener('mouseleave', function () { setExp(false); });
      item.addEventListener('focusin', function () { setExp(true); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) setExp(false); });
    });
  })();

  
